module.exports = __webpack_public_path__ + "img/icraproNewIcon.44cb9032.svg";